

















import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobUserAssignment } from '@/models/jobStatus/jobUserAssignment';
import * as JobsAPI from '@/api/jobsApi';
import JobStatusDetail from '@/components/jobStatus/JobStatusDetail.vue';
import Nullable from '@/types/nullable';
import { Job } from '@/models/jobDetail/job';

@Component({
  components: {
    JobStatusDetail
  }
})
export default class ViewJob extends Vue {
  private loading: boolean = false;
  private errorMessage: string = null;
  private jobUserAssignment: Nullable<JobUserAssignment> = null;
  
  created() {
    this.init();
  }

  handleDataChanged(event: any){  
    var showServiceForm = event.showServiceForm; 
    var shouldSendEmail = event.shouldSendEmail;
    if(showServiceForm) {
      this.$router.push({ name: 'viewjobserviceform', params: { jobID: this.$route.params.jobID, shouldSendEmail: shouldSendEmail } });
    } else {
      this.init();
    }
  }

  async init(){
    this.loading = true;

    try {
      this.jobUserAssignment = await JobsAPI.getStatusHistory(this.$route.params.jobID);
    } catch (err){
      this.errorMessage = err;
    }

    this.loading = false;
  }
}

